// Document numbers: {ENT}-{DOC}-{####}-{YYYY} (02-DATA-MODEL "Numbering"). One counter per
// entity, document type and year; the year resets the sequence.

export const ENTITIES = ['SMC', 'VIB', 'MED'] as const;
export const DOC_TYPES = ['PR', 'PO', 'DN', 'PV', 'PC', 'CT'] as const;
export type EntityCode = (typeof ENTITIES)[number];
export type DocType = (typeof DOC_TYPES)[number];

export interface DocNumber {
  entity: EntityCode;
  doc: DocType;
  seq: number;
  year: number;
}

function checkYear(year: number): void {
  if (!Number.isInteger(year) || year < 2000 || year > 2999)
    throw new Error(`Invalid year: ${year}`);
}

export function seriesKey(entity: EntityCode, doc: DocType, year: number): string {
  checkYear(year);
  return `${entity}-${doc}-${year}`;
}

export function formatDocNumber(
  entity: EntityCode,
  doc: DocType,
  seq: number,
  year: number,
): string {
  if (!Number.isInteger(seq) || seq < 1) throw new Error(`Invalid sequence number: ${seq}`);
  checkYear(year);
  return `${entity}-${doc}-${String(seq).padStart(4, '0')}-${year}`;
}

const PATTERN = new RegExp(`^(${ENTITIES.join('|')})-(${DOC_TYPES.join('|')})-(\\d{4,})-(\\d{4})$`);

export function parseDocNumber(value: string): DocNumber | null {
  const m = PATTERN.exec(value);
  if (!m) return null;
  const seq = Number(m[3]);
  if (seq < 1) return null;
  return { entity: m[1] as EntityCode, doc: m[2] as DocType, seq, year: Number(m[4]) };
}

// The number series and yearly lists follow the group's head-office calendar (Asia/Riyadh).
const RIYADH_YEAR = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Riyadh', year: 'numeric' });

export function businessYear(at: Date): number {
  return Number(RIYADH_YEAR.format(at));
}
